import { Box, Typography } from '@mui/material';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import { commonStyles } from '~/theme/styles/commonStyles';

interface IAssetManagerFieldTooltipProps {
  label: string;
  text: string;
}

export const AssetManagerFieldTooltip = ({ label, text }: IAssetManagerFieldTooltipProps) => {
  return (
    <Box sx={{ ...commonStyles.centerFlexContainer, gap: 0.5 }}>
      <Typography variant="body2">{label}</Typography>
      <InfoTooltip title={text} iconStyles={() => ({ height: 19 })} />
    </Box>
  );
};
